export const VatRadioSkeleton = () => (
  <div data-testid='dynamic-input-field'>
    <div className='flex flex-col md:flex-row gap-4 mb-3'>
      {['false', 'true'].map((value, index) => (
        <div
          key={value}
          className={`flex items-center flex-1 p-6 bg-tertiary animate-pulse rounded-lg ${
            index === 0 ? 'border-hard' : 'border-extra-soft'
          }`}>
          <div className='w-full h-6 bg-tertiary-light rounded-sm' />
        </div>
      ))}
    </div>
  </div>
);
